import ApiHttp from '../http';

class ErrorHandler {

    constructor() {
        this._ignoreError = false;
        this._ignoreSuccess = false;

    }


    ignoreNextError() {
        this._ignoreError = true;
    }

    ignoreNextResponse() {
        this._ignoreSuccess = true;
    }

    ignoreNextRequest() {
        this.ignoreNextError();
        this.ignoreNextResponse();
    }

    handle(responseCallback, ErrorCallback) {

        let callbackError = (e)=> {
            var canRun = !this._ignoreError;
            this._ignoreError = false;
            this._ignoreSuccess = false;
            return Promise.reject(canRun ? ErrorCallback(e) : e);
        }

        let callbackSuccess = (r)=> {
            var canRun = !this._ignoreSuccess

            this._ignoreError = false;
            this._ignoreSuccess = false;

            return canRun ? responseCallback(r) :r;
        }

        return ApiHttp.interceptors.response.use(callbackSuccess, callbackError);
    }


}

export default new ErrorHandler();



// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/error-handler.js